export default __webpack_public_path__ + "static/media/vertical-logo.80be8bd3.png";